import { useDashboardPrefs } from '../../../lib/dashboards/userPrefs';
import { snoozeInvite } from '../../../lib/dashboards/rollout';

/**
 * "Dashboard: nuova o di prima" nel profilo (design 22/10/2026, tavola 7 punto 6).
 * Se l'azienda ha deciso per tutti, la scelta personale vale solo finche' e' concessa (rollout).
 */
export default function DashboardVersionChoice() {
  const { prefs, save } = useDashboardPrefs();
  const isNew = prefs.version === 'new';
  const pick = (v: 'new' | 'classic') => {
    if (v === (isNew ? 'new' : 'classic')) return;
    void save(v === 'new' ? { version: 'new', version_at: new Date().toISOString(), checkin_done: false } : { version: 'classic', ...snoozeInvite(prefs) });
  };
  const opt = (on: boolean) => `flex flex-1 cursor-pointer gap-2.5 rounded-lg p-3 ${on ? 'border-[1.5px] border-[#E0306F] bg-[#FDF0F4]' : 'border border-[rgba(55,53,47,0.16)] hover:bg-[#FBFBFA] dark:border-gray-600'}`;
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm font-medium text-[#37352F] dark:text-white">Dashboard</span>
      <div className="flex flex-col gap-2 sm:flex-row" role="radiogroup" aria-label="Quale Dashboard usare">
        <label className={opt(isNew)}>
          <input type="radio" name="dash-version" checked={isNew} onChange={() => pick('new')} className="mt-0.5 accent-[#E0306F]" />
          <span className="flex flex-col"><span className="text-sm font-semibold text-[#37352F] dark:text-white">Nuova</span><span className="text-xs text-[#9B9A97]">a blocchi, la componi tu</span></span>
        </label>
        <label className={opt(!isNew)}>
          <input type="radio" name="dash-version" checked={!isNew} onChange={() => pick('classic')} className="mt-0.5 accent-[#E0306F]" />
          <span className="flex flex-col"><span className="text-sm font-semibold text-[#37352F] dark:text-white">Di prima</span><span className="text-xs text-[#9B9A97]">com’era fino a ottobre</span></span>
        </label>
      </div>
    </div>
  );
}
